import styled from 'styled-components';

const getSurfaceBg = (props) => (props.theme && props.theme.colors && props.theme.colors.surface && props.theme.colors.surface.background) || '#f0faff';
const getFontFamily = (props) => (props.theme && props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif';
const getBrandSecondary = (props) => (props.theme && props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.secondary) || '#00a9ff';

export const Container = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => getSurfaceBg(props)};
  border: 1px solid #d5eff5;
  border-radius: 6px;
  padding: 12px 16px;
  gap: 16px;
  font-family: ${props => getFontFamily(props)};
  margin-top: 8px;
  
  ${props => props.onClick && `
    cursor: pointer;
    transition: background-color 0.2s, border-color 0.2s;
    &:hover {
      background-color: #dcf3f8;
      border-color: #b5e1eb;
    }
  `}
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => getBrandSecondary(props)};
  font-size: 20px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 13px;
  color: #6a7c82;
  line-height: 1.5;
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/InfoBox/components/InfoBoxStyles.js